import styled from 'styled-components';

import { NEUTRAL_COLORS } from '../styles/colors';

export const S = {
  Wrapper: styled.div`
    display: flex;
    width: 100%;
    position: relative;
    align-items: center;
  `,

  Progressbar: styled.div`
    position: absolute;
    left: 15px;
    right: 15px;
    background-color: ${NEUTRAL_COLORS['charcoal-alpha-50']};
    height: 8px;
    z-index: 1;
    border-radius: 8px;
  `,

  ProgressbarFill: styled.div<{ $progressPercent: number }>`
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: ${NEUTRAL_COLORS['charcoal-500']};
    width: ${({ $progressPercent }) => `${$progressPercent}%`};
    transition: width 0.3s ease;
    border-radius: 8px;
  `,

  Steps: styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    z-index: 2;
  `,

  Step: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  `
};
